import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types'; // Optional: for prop validation

/**
 * Common Component for Displaying the message for No data available or any other error message.
 */
const EmptyState = ({ 
  message = "No data available", 
  height = "200px",
  minHeight = "200px", 
  icon = null,
  variant = "h6",
  /** Merged last so callers can override e.g. bgcolor when nested inside Paper */
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: height, // Configurable height
        minHeight: minHeight,
        width: '100%',
        p: 3,
        textAlign: 'center',
        bgcolor: 'background.paper',
        ...sx,
      }}
    >
      {/* If an icon is passed, render it with some bottom margin */}
      {icon && (
        <Box sx={{ mb: 2, color: 'text.secondary', opacity: 0.5 }}>
          {icon}
        </Box>
      )}
      
      <Typography 
        variant={variant} 
        color="text.secondary"
        fontWeight="normal"
      >
        {message}
      </Typography>
    </Box>
  );
};

// Optional: PropTypes for better type checking in JS projects
EmptyState.propTypes = {
  message: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.node,
  sx: PropTypes.object,
};

export default EmptyState;